import { pickRandom } from '../util';
import Base from './base';
import { MoveTypes } from './types';
export class DamageAll extends Base {
    constructor() {
        super();
        this.description = 'Multiple target attack';
        this.type = Math.random() > 0.5 ?
            MoveTypes.Magical :
            MoveTypes.Physical;
        this.power = pickRandom([
            [30, 65],
            [50, 35],
        ]);
        this.manaCost = this.power === 30 ? 10 : 20;
    }
}
export class DamageOne extends Base {
    constructor() {
        super();
        this.description = 'Single target attack';
        this.type = Math.random() > 0.5 ?
            MoveTypes.Magical :
            MoveTypes.Physical;
        this.power = pickRandom([
            [70, 65],
            [100, 35],
        ]);
        this.manaCost = this.power === 70 ? 10 : 20;
    }
}
export class DebuffAll extends Base {
    constructor() {
        super(...arguments);
        this.description = 'Multiple target debuff';
    }
}
export class DebuffOne extends Base {
    constructor() {
        super(...arguments);
        this.description = 'Single target debuff';
    }
}
export class BuffAll extends Base {
    constructor() {
        super(...arguments);
        this.description = 'Multiple target buff';
    }
}
export class BuffOne extends Base {
    constructor() {
        super(...arguments);
        this.description = 'Single target buff';
    }
}
export class AttributeUp extends Base {
    constructor() {
        super(...arguments);
        this.description = 'Single target buff';
    }
}
export class AttributeDown extends Base {
    constructor() {
        super(...arguments);
        this.description = 'Single target debuff';
    }
}
/**
 * Element attacks
 */
export class FireAll extends DamageAll {
    constructor() {
        super(...arguments);
        this.name = 'FireAll';
    }
}
export class FireOne extends DamageOne {
    constructor() {
        super(...arguments);
        this.name = 'FireOne';
    }
}
export class WaterAll extends DamageAll {
    constructor() {
        super(...arguments);
        this.name = 'WaterAll';
    }
}
export class WaterOne extends DamageOne {
    constructor() {
        super(...arguments);
        this.name = 'WaterOne';
    }
}
export class EarthAll extends DamageAll {
    constructor() {
        super(...arguments);
        this.name = 'EarthAll';
    }
}
export class EarthOne extends DamageOne {
    constructor() {
        super(...arguments);
        this.name = 'EarthOne';
    }
}
export class ElectricAll extends DamageAll {
    constructor() {
        super(...arguments);
        this.name = 'ElectricAll';
    }
}
export class ElectricOne extends DamageOne {
    constructor() {
        super(...arguments);
        this.name = 'ElectricOne';
    }
}
export class FlyingAll extends DamageAll {
    constructor() {
        super(...arguments);
        this.name = 'FlyingAll';
        this.type = MoveTypes.Physical;
    }
}
export class FlyingOne extends DamageOne {
    constructor() {
        super(...arguments);
        this.name = 'FlyingOne';
        this.type = MoveTypes.Physical;
    }
}
export class PhysicalAll extends DamageAll {
    constructor() {
        super(...arguments);
        this.name = 'PhysicalAll';
        this.type = MoveTypes.Physical;
    }
}
export class PhysicalOne extends DamageOne {
    constructor() {
        super(...arguments);
        this.name = 'PhysicalOne';
        this.type = MoveTypes.Physical;
    }
}
/**
 * Element debuffs
 */
export class BurnAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'BurnAll';
    }
}
export class BurnOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'BurnOne';
    }
}
export class PoisonAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'PoisonAll';
    }
}
export class PoisonOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'PoisonOne';
    }
}
export class SoakAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'SoakAll';
    }
}
export class SoakOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'SoakOne';
    }
}
export class ShockAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'ShockAll';
    }
}
export class ShockOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'ShockOne';
    }
}
export class WeakenAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'WeakenAll';
    }
}
export class WeakenOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'WeakenOne';
    }
}
/**
 * Attribute buffs
 */
export class AttackUpAll extends BuffAll {
    constructor() {
        super(...arguments);
        this.name = 'AttackUpAll';
    }
}
export class AttackUpOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'AttackUpOne';
    }
}
export class MagicUpAll extends BuffAll {
    constructor() {
        super(...arguments);
        this.name = 'MagicUpAll';
    }
}
export class MagicUpOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'MagicUpOne';
    }
}
export class DefenseUpAll extends BuffAll {
    constructor() {
        super(...arguments);
        this.name = 'DefenseUpAll';
    }
}
export class DefenseUpOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'DefenseUpOne';
    }
}
export class SpeedUpAll extends BuffAll {
    constructor() {
        super(...arguments);
        this.name = 'SpeedUpAll';
    }
}
export class SpeedUpOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'SpeedUpOne';
    }
}
export class LuckUpAll extends BuffAll {
    constructor() {
        super(...arguments);
        this.name = 'LuckUpAll';
    }
}
export class LuckUpOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'LuckUpOne';
    }
}
export class HealthUpAll extends BuffAll {
    constructor() {
        super(...arguments);
        this.name = 'HealthUpAll';
    }
}
export class HealthUpOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'HealthUpOne';
    }
}
export class ManaUpAll extends BuffAll {
    constructor() {
        super(...arguments);
        this.name = 'ManaUpAll';
    }
}
export class ManaUpOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'ManaUpOne';
    }
}
/**
 * Attribute debufs
 */
export class AttackDownAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'AttackDownAll';
    }
}
export class AttackDownOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'AttackDownOne';
    }
}
export class MagicDownAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'MagicDownAll';
    }
}
export class MagicDownOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'MagicDownOne';
    }
}
export class DefenseDownAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'DefenseDownAll';
    }
}
export class DefenseDownOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'DefenseDownOne';
    }
}
export class SpeedDownAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'SpeedDownAll';
    }
}
export class SpeedDownOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'SpeedDownOne';
    }
}
export class LuckDownAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'LuckDownAll';
    }
}
export class LuckDownOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'LuckDownOne';
    }
}
export class HealthDownAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'HealthDownAll';
    }
}
export class HealthDownOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'HealthDownOne';
    }
}
export class ManaDownAll extends DebuffAll {
    constructor() {
        super(...arguments);
        this.name = 'ManaDownAll';
    }
}
export class ManaDownOne extends DebuffOne {
    constructor() {
        super(...arguments);
        this.name = 'ManaDownOne';
    }
}
/**
 * Generic buffs
 */
export class MultiStrikeBuffOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'MultiStrikeBuffOne';
    }
}
export class ReflectBuffOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'ReflectBuffOne';
    }
}
export class WallBuffOne extends BuffOne {
    constructor() {
        super(...arguments);
        this.name = 'WallBuffOne';
    }
}
export const AllMoves = {
    FireAll,
    FireOne,
    WaterAll,
    WaterOne,
    EarthAll,
    EarthOne,
    ElectricAll,
    ElectricOne,
    FlyingAll,
    FlyingOne,
    PhysicalAll,
    PhysicalOne,
    BurnAll,
    BurnOne,
    PoisonAll,
    PoisonOne,
    SoakAll,
    SoakOne,
    ShockAll,
    ShockOne,
    WeakenAll,
    WeakenOne,
    AttackUpAll,
    AttackUpOne,
    MagicUpAll,
    MagicUpOne,
    DefenseUpAll,
    DefenseUpOne,
    SpeedUpAll,
    SpeedUpOne,
    LuckUpAll,
    LuckUpOne,
    HealthUpAll,
    HealthUpOne,
    ManaUpAll,
    ManaUpOne,
    AttackDownAll,
    AttackDownOne,
    MagicDownAll,
    MagicDownOne,
    DefenseDownAll,
    DefenseDownOne,
    SpeedDownAll,
    SpeedDownOne,
    LuckDownAll,
    LuckDownOne,
    HealthDownAll,
    HealthDownOne,
    ManaDownAll,
    ManaDownOne,
    MultiStrikeBuffOne,
    ReflectBuffOne,
    WallBuffOne,
};
export class MovesGenerator {
    static generateFromCode(numMovesCode, movesCode) {
        const { [MovesGenerator.numMovesKey]: numMoves } = JSON.parse(numMovesCode);
        const { [MovesGenerator.movesKey]: moves } = JSON.parse(movesCode);
        return {
            numMoves,
            moves: moves.map(move => new AllMoves[move]()),
        };
    }
    static generateNumMovesCode(num) {
        return JSON.stringify({
            [MovesGenerator.numMovesKey]: num,
        });
    }
    static generateMoves(maxPoints) {
        const moves = [];
        while (moves.length < MovesGenerator.totalMoves) {
            const randomMove = pickRandom(Object.keys(AllMoves));
            if (!moves.includes(randomMove))
                moves.push(randomMove);
        }
        return [JSON.stringify({
                [MovesGenerator.movesKey]: moves,
            }), 0];
    }
}
MovesGenerator.numMovesKey = 'numMoves';
MovesGenerator.movesKey = 'moves';
MovesGenerator.totalMoves = 10;
// Moves
//     -----
//     - [Water, Fire, Earth, Electric, Flying, Physical] All
//     - [Water, Fire, Earth, Electric, Flying, Physical] Single
//     - [Water, Fire, Earth, Electric, Flying, Physical] Debuff
//     - [Atk, Mag, Def, Speed, Luck, Health, Mana] Up
//     - [Atk, Mag, Def, Speed, Luck, Health, Mana] Down
//     - [Multi-Strike, Reflect, Wall]
